'use client'

import { useAuthorization } from '@entities/authentication'
import { resetTelemetryUser, setTelemetryUser } from '@shared/libs/logger/telemetry-user'
import { type ReactNode, useEffect } from 'react'

/**
 * 로그인 상태에 따라 브라우저 OTel 텔레메트리(로그/트레이스)에 user.id를 설정한다.
 * Sentry.setUser / SentryUserProvider의 대체.
 */
export const TelemetryUserProvider = ({ children }: { children: ReactNode }) => {
  const authState = useAuthorization()

  useEffect(() => {
    if (authState.isAuthorized && authState.uid) {
      setTelemetryUser(String(authState.uid))
    } else {
      resetTelemetryUser()
    }
  }, [authState.isAuthorized, authState.uid])

  return <>{children}</>
}
